"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  quote: "Signature Occasions turned our wedding into a moonlit dream. The lavender accents and silver details were more beautiful than we ever imagined.",
  name: "Julianne & Marc",
  company: "PRIVATE ESTATE WEDDING"
}, {
  quote: "The level of sophistication they brought to our annual gala was unparalleled. Every guest felt the luxury in the atmosphere they created.",
  name: "Alistair Thorne",
  company: "CORPORATE ANNIVERSARY GALA"
}, {
  quote: "From the first consultation to the final toast, their team handled every detail with grace. It was truly an ethereal experience for everyone.",
  name: "Sophia Laurent",
  company: "LUXURY BIRTHDAY SOIRÉE"
}];
export default function KindWords() {
  return <section data-section-id="262165" id="kind-words" className="bg-background text-foreground py-24 md:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none opacity-[0.05] text-[300px] md:text-[500px] font-serif text-secondary-foreground leading-none">
        &ldquo;
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10">
        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 md:px-12">
                  <p className="text-2xl md:text-[40px] leading-relaxed md:leading-tight italic font-serif font-light mb-10 text-primary tracking-tight">
                    "{testimonial.quote}"
                  </p>
                  <div className="flex flex-col items-center gap-1.5">
                    <span className="text-lg font-medium text-foreground font-default">
                      {testimonial.name}
                    </span>
                    <span className="text-xs text-muted-foreground font-default uppercase tracking-[0.2em]">
                      {testimonial.company}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex justify-center items-center gap-6 mt-16">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-transparent border-secondary hover:bg-accent hover:text-accent-foreground size-12 rounded-md transition-all duration-300" />
            <CarouselNext className="static translate-y-0 translate-x-0 bg-transparent border-secondary hover:bg-accent hover:text-accent-foreground size-12 rounded-md transition-all duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}